import { Link, TableCell, Tooltip, Typography } from "@mui/material";
import { FC } from "react";

type TableCellWithToolTipProps = {
  title: string;
  color?: string;
  colSpan?: number;
  description?: string;
  link?: string;
  align?: "center" | "left" | "right" | "justify" | "inherit" | undefined
};

const TableCellWithToolTip: FC<TableCellWithToolTipProps> = ({
  title,
  color,
  colSpan,
  description,
  link,
  align="center"
}) => {
  return (
    <TableCell
      sx={{ overflow: "hidden", textOverflow: "ellipsis", backgroundColor: color || "white"}}
      colSpan={colSpan}
      align={link ? "left" : align}
    >
      <Tooltip title={title} placement="top" leaveDelay={0} >
        <Typography
          variant="body2"
          sx={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: '100%'
          }}
        >
          {title}
        </Typography>
      </Tooltip>
      {description && link ? (
        <Link
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
          href={link}
        >
          [{description}]
        </Link>
      ) : null}
    </TableCell>
  );
};

export default TableCellWithToolTip;
